import Select, { createFilter, components as Components } from 'react-select'
import Label from '../_shared/Label/Label'
import styles from './style.module.css'
import { useCallback, useState } from 'react'
import './reactSelect.css'
import CustomMenuList from './CustomMenuList'
import CustomOption from './CustomOption'

const Option = (props) => {
    const { onMouseMove, onMouseOver, ...rest } = props.innerProps
    const newProps = { ...props, innerProps: rest }
    const optionStyle = {
        display: 'flex',
        alignItems: 'center',
        padding: '5px 10px',
        backgroundColor: props?.isSelected
            ? 'white'
            : props?.isFocused
                ? '#f0f0f0'
                : 'white',
        color: props?.isSelected ? '#004400' : '#333',
        borderRadius: '4px',
        marginBottom: '2px',
        cursor: 'pointer',
        border: '1px solid #ccc',
    }
    const checkboxStyle = {
        marginRight: '10px',
    }

    const labelStyle = {
        margin: 0,
        fontWeight: props?.isSelected ? 'bold' : 'normal',
        color: '#000000',
    }
    return (
        <Components.Option {...newProps} style={optionStyle}>
            <input
                type="checkbox"
                checked={props.isSelected}
                onChange={() => null}
                style={checkboxStyle}
            />{' '}
            <label style={labelStyle}>{props.label}</label>
        </Components.Option>
    )
}

const ReactSelect = ({
    name,
    touched,
    errors,
    options,
    labelText,
    setFieldTouched,
    setFieldError,
    setFieldValue,
    values,
    value,
    disabled,
    MultiSelect = false, // Changed from isMulti to MultiSelect
    isClearable = true,
    isShowLabel = true,
    onOptionChange,
}) => {
    const [isFocused, setIsFocused] = useState(false)

    const handleBlur = useCallback(() => {
        setIsFocused(false)
        setFieldTouched(name, true)
        if (!values?.[name] || (MultiSelect && values?.[name]?.length === 0)) {
            setFieldError(name, true)
        } else {
            setFieldError(name, false)
        }
    }, [name, setFieldError, setFieldTouched, values, MultiSelect])

    const handleFocus = () => {
        setIsFocused(true)
    }

    const getFieldClasses = (touched, errors) => {
        const classes = ['']

        if (!isFocused) {
            if (touched && errors) {
                classes.push('border border-1 border-danger rounded')
            }

            if (touched && !errors) {
                classes.push(
                    'border border-1 border-success rounded ',
                    styles['input-touched']
                )
            }
        }

        return classes.join(' ')
    }

    const handleChange = (selectedOptions) => {
        if (MultiSelect) {
            // Special handling for device_type_tx field (stores array of IDs, not option objects)
            if (name === 'device_type_tx') {
                const selectedValues = selectedOptions ? selectedOptions.map(option => String(option.value)) : [];
                setFieldValue(name, selectedValues);
            } else {
                setFieldValue(name, selectedOptions || [])
            }
            onOptionChange?.(selectedOptions)
        } else {
            setFieldValue(name, selectedOptions?.value || '')
            onOptionChange?.(selectedOptions)
        }
    }


    return (
        <>
            {isShowLabel && <Label labelText={labelText} />}
            <div>
                <Select
                    isDisabled={disabled}
                    value={
                        MultiSelect
                            ? (() => {
                                // Special handling for device_type_tx (stores array of string IDs)
                                if (name === 'device_type_tx') {
                                    const fieldValue = values?.[name];
                                    if (Array.isArray(fieldValue)) {
                                        return options?.filter((opt) => fieldValue.includes(String(opt.value)));
                                    } else if (typeof fieldValue === 'string' && fieldValue) {
                                        const valuesArray = fieldValue.split(',').map(v => v.trim()).filter(v => v && v !== '-1');
                                        return options?.filter((opt) => valuesArray.includes(String(opt.value)));
                                    }
                                    return [];
                                } else {
                                    return options?.filter((opt) => values?.[name]?.some?.((val) => val?.value === opt.value))
                                }
                            })()
                            : options?.find((option) => option.value === values?.[name]) || null
                    }
                    name={name}
                    classNames={{
                        control: (state) =>
                            state.isFocused
                                ? 'border react-select-container border-1 mt-1 '
                                : `mt-1 react-select-container ${getFieldClasses(
                                    touched?.[name],
                                    errors?.[name]
                                )}`,
                    }}
                    classNamePrefix="react-select"
                    onChange={handleChange}
                    options={options}
                    isClearable={isClearable}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    menuPosition="fixed"
                    isMulti={MultiSelect}
                    hideSelectedOptions={false}
                    filterOption={createFilter({ ignoreAccents: false })}
                    components={{
                        Option: MultiSelect ? Option : CustomOption,
                        MenuList: CustomMenuList,
                    }}
                />

            </div>
        </>
    )
}

export default ReactSelect
